<template>
    <div>
   <div v-if="!labelId" class="no-data">未选择标签</div>
    <div v-if="labelId" class="memberList-warp" v-loading="loading">
        <div class="memberList-warp-header">
            <span class="fl label-name">{{labelName}}
                (<span style="color: #2a84dc">{{total}}</span>)人</span>
            <el-link type="primary"  @click="openDetail" class="fr">查看详情</el-link>
        </div>
        <div class="memberList-warp-handle">
            <el-button class="ml10 mr10" type="primary" @click="addUser">添加成员</el-button>
            <el-dropdown  class="mr10" type="primary" @command="handleCommand">

                <el-button type="primary">
                    批量导入/导出<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="importExcel">导入标签</el-dropdown-item>
                    <el-dropdown-item command="exportExcel">导出标签</el-dropdown-item>
                    <el-dropdown-item command="downloadTemplate">模板下载</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <el-button class="mr10"  type="primary" @click="batchDelHandle" :disabled="!list.length">移出</el-button>
        </div>


        <div class="w100 pl10 pr10 pb10 memberList" >
            <div class="table-con">
                <el-table class="w100 mt20 table" header-row-class-name="table-head"
                          row-class-name="cu-p" stripe :data="list"  @selection-change="changeFun">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column align="center" prop="username" width="200px" label="用户名"></el-table-column>
                    <el-table-column align="left" label="用户部门">
                        <template slot-scope="scope">
                            {{scope.row.userDeptName | userDeptNameFilter}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="mt20 flex-box">
                <div class="flex-1"></div>
                <el-pagination background @size-change="changeSize"
                               @current-change="changePage"
                               :current-page="paramSearch.current"
                               :page-sizes="pageSizes"
                               :page-size="paramSearch.size"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total"
                ></el-pagination>
            </div>
        </div>
        <charge-person
                ref="personModal"
                :personData="personData"
                @closePerson="closePerson"
        />
        <importExcel
                ref="uplodModal"
                :uplodData="uplodData"
                @closeUplod="closeUplod"
                @successCallBack="successCallBack"
        ></importExcel>
    </div>
    </div>
</template>

<script>

    import { gettLabelpage,handleOut,handleAddUser,getLabelInfo} from '@/api/managementCenter/labelManage';
    import  chargePerson from "@/components/management/reportManage/chargePerson.vue";
    import * as serve from '@/api/importAndExport/excelApi';
    import importExcel from "@/components/dialog/deptManage/importExcel.vue";
    export default {
        name: "memberList",
        components: {
            chargePerson,
            importExcel
        },
        props: [],
        data() {
            return {
                loading:false,
                list: [],
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10,
                    name:''
                },
                total: 0,
                labelId:'',
                labelName:'',
                selectionChecked:[],
                personData: {
                    userData: [],
                    state: false,
                    disabled: false,
                    data: null
                },
                uplodData: {
                    state: false,
                    type: ""
                },

            }
        },
        computed: {

        },
        mounted() {},
        methods: {
            changeFun(val) {
              this.selectionChecked=val;
            },
            loadListFn(item){
                this.labelId=item.labelId;
                this.labelName=item.labelName;
                if(this.labelId){
                    this.getListFn();
                }
            },
            // 获取查询列表
            getListFn () {
                this.list = [];
                this.total = 0;
                this.loading = true;
                gettLabelpage({...this.paramSearch,labelId:this.labelId})
                    .then(({data})=> {
                        this.loading = false;
                        if(data.code == 0){
                            this.selectionChecked=[];
                            this.list = data.data.records || [];
                            this.total = data.data.total;
                        }
                    }).catch(() => {
                    this.loading = false;
                });
            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.getListFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.getListFn();
            },
            openDetail(){
                this.$emit('openDetail',this.labelId)
            },
            batchDelHandle(){
                if(this.selectionChecked.length==0){
                    this.$message.warning( "请勾选要移出的人员" );
                    return;
                }

                this.$confirm( "是否确定删除?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let ids= (this.selectionChecked.map(i=>i.userId )).toString();
                    this.deleteHttp(ids);
                }).catch(() => {
                    this.$message.info( "已取消删除" );

                });
            },
            deleteHttp(ids){
                this.loading = true;
                // 删除接口
                let params = {
                    labelId: this.labelId || '',
                    labelUserIds: ids
                }
                handleOut(params).then( ({data}) => {
                    this.loading = false;
                    if(data.code == 0){
                        this.$message.success("移出成功!" );
                        this.getListFn();
                    }else{
                        this.$message.warning( data.msg||"移出失败！" );
                    }
                }).catch(() => {
                    this.loading = false;
                    this.$message.error( "删除异常!" );
                });
            },
            //显示人员选择
            addUser() {
                 this.getLabelInfoFn(this.labelId).then(()=>{
                     this.$refs.personModal.loadData();
                     this.personData.state = true;
                 })
            },
            //选择人员
            closePerson(value) {
                if (!value.mans) {
                    this.personData.state = false;
                    return;
                }
                let mans=value.mans||[];
                let userList= mans.map(item=>{
                    return {userId:item.userId};
                });
                this.handleAddUserFn(userList);
            },
            getLabelInfoFn(id){
                return new Promise((resolve) => {
                    this.loading = true;
                    getLabelInfo(id).then(({data}) => {
                        this.loading = false;
                        if (data.code == 0) {
                            this.personData.data = (data.data.userList || []).map(i => {
                                return {
                                    userId: i.userId,
                                    name: i.username
                                }
                            });
                            this.personData.userData = (data.data.userList || []).map(i => {
                                return i.userId;
                            });
                            resolve();
                        } else {
                            this.$message.warning(data.msg || "获取标签信息失败！");
                        }
                    }).catch(err => {
                        this.loading = false;
                    })
                })
            },
            handleAddUserFn(userList){
                this.$refs.personModal.$refs.selectUser.sureBtnDisabled=true;
                let data={
                    labelId:this.labelId,
                    userList
                }
                this.loading = true;
                handleAddUser(data).then(({data})=>{
                    this.loading = false;
                    this.$refs.personModal.$refs.selectUser.sureBtnDisabled=false;
                    if(data.code == 0) {
                        this.$message.success(  "添加成员成功!" );
                        this.personData.state = false;
                        this.paramSearch.size=10;
                        this.paramSearch.current=1;
                        this.getListFn();
                    }else{
                        this.$message.warning(  data.msg||"添加成员失败!" );
                    }
                }).catch(err=>{
                    this.$refs.personModal.$refs.selectUser.sureBtnDisabled=false;
                    this.loading = false;
                })
            },
            handleCommand(commandType){
                switch(commandType) {
                    case 'importExcel':
                         this.importExcelFn();
                        break;
                    case 'exportExcel':
                        this.downloadFn(serve.excelExport('label'));
                        break;
                    case 'downloadTemplate':
                        this.downloadFn(serve.downloadTemplate('label'));
                        break;
                }
            },

            importExcelFn(){
                this.uplodData.state = true;
                this.uplodData.type = "label";
            },
            closeUplod(val) {
                this.uplodData.state = val;
            },
            successCallBack(){
                this.$emit('saveSuccess')

            },
            downloadFn(url){
                this.$DownLoad(
                    url,
                    null,
                    res => {
                        if (res.status == 200) {
                        } else {
                            this.$alert("下载出错,请稍后重试", "提示", {
                                confirmButtonText: "确定",
                                type: "warning"
                            });
                        }
                    },
                    error => {
                        this.$alert(error, "提示", {
                            confirmButtonText: "确定",
                            type: "warning"
                        });
                    }
                );

            },

        },
        watch: {

        },
        filters: {
            userDeptNameFilter(value){
                if(value.substr(value.length-1,1)=="/"){
                    value=value.substring(0,value.length-1);
                }
              return value;
            }

        }
    };
</script>

<style scoped lang="less">
    .memberList-warp{
        width: 100%;
        &-header{
            height: 47px;
            width: 100%;
            padding: 10px 10px 15px 10px;
            >.label-name{
                    color: #666666;
                    font-size: 17px;
                    font-weight: bold;
                    /*font-family: kaiti;*/
                }
        }
        .memberList{
            height: calc(100vh - 202px);
        }
        /deep/.el-table {
            width: 100%;
            .el-table__body-wrapper {
                max-height: calc(100vh - 330px);
                overflow-y: auto;

            }
        }
    }

</style>
